import { render, staticRenderFns } from "./StationEvent.vue?vue&type=template&id=4197e00f&scoped=true&"
import script from "./StationEvent.vue?vue&type=script&lang=js&"
export * from "./StationEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197e00f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4197e00f')) {
      api.createRecord('4197e00f', component.options)
    } else {
      api.reload('4197e00f', component.options)
    }
    module.hot.accept("./StationEvent.vue?vue&type=template&id=4197e00f&scoped=true&", function () {
      api.rerender('4197e00f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StationEvent/StationEvent.vue"
export default component.exports